const paymentModeTransformer = response => {
  return response?.map(e => ({ ...response, key: e?.key, label: e?.name, value: e?.name, id: e?.id }))
}

export default paymentModeTransformer
